import React from 'react';
import { useTranslation } from 'react-i18next';

const Features = () => {
  const { t } = useTranslation();

  return (
    <div className="container mb-5 pb-4 mt-6 mt-80">
      <div className="email-list">
        <h1 className="font-weight-normal text-7 mb-4 mr-3">
          {t('featureList.title')}:{' '}
          <strong className="font-weight-extra-bold-title">
            {t('featureList.titleHighlight')}
          </strong>
        </h1>
        <p className="sub-title mb-5">{t('featureList.description')}</p>
        <div className="row">
          <div className="col-sm-6">
            <FeatureBox
              iconClass="fas fa-user-secret"
              title={t('featureList.completePrivacy.title')}>
              <span>
                {t('featureList.completePrivacy.textBefore')}{' '}
                <strong className="font-weight-extra-bold">
                  {t('featureList.completePrivacy.textHighlight')}
                </strong>{' '}
                {t('featureList.completePrivacy.textAfter')}
              </span>
            </FeatureBox>
            <FeatureBox
              iconClass="fas fa-shield-alt"
              title={t('featureList.noSpam.title')}>
              <span>
                <strong className="font-weight-extra-bold">
                  {t('featureList.noSpam.textHighlight')}
                </strong>{' '}
                {t('featureList.noSpam.textAfter')}
              </span>
            </FeatureBox>
            <FeatureBox
              iconClass="fas fa-key"
              title={t('featureList.noSignUp.title')}>
              <span>
                {t('featureList.noSignUp.textBefore')}{' '}
                <strong className="font-weight-extra-bold">
                  {t('featureList.noSignUp.textHighlight')}
                </strong>{' '}
                {t('featureList.noSignUp.textAfter')}
              </span>
            </FeatureBox>
            <FeatureBox
              iconClass="fas fa-lock"
              title={t('featureList.convenience.title')}>
              <span>
                {t('featureList.convenience.textBefore')}{' '}
                <strong className="font-weight-extra-bold">
                  {t('featureList.convenience.textHighlight')}
                </strong>{' '}
                {t('featureList.convenience.textAfter')}
              </span>
            </FeatureBox>
          </div>
          <div className="col-sm-6">
            <FeatureBox
              iconClass="fas fa-lock"
              title={t('featureList.shortTermUse.title')}>
              <span>
                {t('featureList.shortTermUse.textBefore')}{' '}
                <strong className="font-weight-extra-bold">
                  {t('featureList.shortTermUse.textHighlight')}
                </strong>{' '}
                {t('featureList.shortTermUse.textAfter')}
              </span>
            </FeatureBox>
            <FeatureBox
              iconClass="fas fa-lock"
              title={t('featureList.gdprCompliant.title')}>
              <span>
                {t('featureList.gdprCompliant.textBefore')}{' '}
                <strong className="font-weight-extra-bold">
                  {t('featureList.gdprCompliant.textHighlight')}
                </strong>{' '}
                {t('featureList.gdprCompliant.textAfter')}
              </span>
            </FeatureBox>
            <FeatureBox
              iconClass="fas fa-code"
              title={t('featureList.forDevelopers.title')}>
              <span>
                {t('featureList.forDevelopers.textBefore')}{' '}
                <strong className="font-weight-extra-bold">
                  {t('featureList.forDevelopers.textHighlight')}
                </strong>{' '}
                {t('featureList.forDevelopers.textAfter')}
              </span>
            </FeatureBox>
            <FeatureBox
              iconClass="fas fa-rocket"
              title={t('featureList.getStarted.title')}>
              <span>
                {t('featureList.getStarted.textBefore')}{' '}
                <strong className="font-weight-extra-bold">
                  {t('featureList.getStarted.textHighlight')}
                </strong>{' '}
                {t('featureList.getStarted.textAfter')}
              </span>
            </FeatureBox>
          </div>
        </div>
      </div>
    </div>
  );
};

const FeatureBox = ({ iconClass, title, children }) => (
  <div className="feature-box feature-box-style-2">
    <div className="feature-box-icon">
      <i className={iconClass}></i>
    </div>
    <div className="feature-box-info">
      <h4 className="font-weight-bold text-4-5 mb-2">{title}</h4>
      <p className="mb-4">{children}</p>
    </div>
  </div>
);

export default Features;
